define('commons/bulk-edit',['jquery', 'commons/popup-dialog', 'tap-messages'], function($, PopupDialog, tapMessages) {

    var BulkEdit = function(options) {
        this.options = {
            'url' : '/baseStation/bulk/edit/post',
            'form': 'form#baseStation',
            'validateButton' : '#validate',
            'mastEqLinked' : '.mast-eq-linked',
            'mastEquipment' : '#mastEquipment',
            'antennaModel' : '#model',
            'ids' : [],
            'isInitial' :true,
            'initialFields':{},
            'changedFields':{},
            'differentFields':[]
        };
        // Extends options
        $.extend(this.options, options);
        this.form = $(this.options.form);
        this.mastEqLinked = $(this.options.mastEqLinked);
        this.mastEquipment = $(this.options.mastEquipment);
        this.antennaModel = $(this.options.antennaModel);
        this.form.attr('action', this.options.url);
        $(this.options.validateButton).click($.proxy(this.validate, this));
        this.init();
    };

    BulkEdit.prototype.init = function() {
        $(':input').each($.proxy(function (index, element) {
            var el = $(element);
            if (this.isDifferentField(el)){
                this.overlay(el);
            }
            el.click($.proxy(this.removeOverlay, this))
              .focus($.proxy(this.removeOverlay, this))
              .blur($.proxy(function() {
                    if (this.isDifferentField(el)) {
                        this.overlay(el);
                    }
                  }, this))
              .change($.proxy(this.onChange, this));
        }, this));
        $('select').each($.proxy(function(index, element) {
            var el = $(element);
            if (!this.isChangedField(el.attr('name'))){
                //handle empty options
                var foundSelect = el.find('option[value=-2]').length;
                var foundEmpty = el.find('option[value=""]').length;
                var count = foundSelect + foundEmpty;
                var optionsLength = el.children('option').length;
                if (optionsLength > count && -1 === $.inArray(el.attr('name'), this.options.differentFields)) {
                    el.find('option[value=-2]').remove();
                    el.find('option[value=""]').remove();
                } else {
                    if (el.find('option[value="-2"]').length) {
                        el.val(-2);
                    } else {
                        el.val('');
                    }
                }
            }
        }, this));

        this.mastEquipment.change($.proxy(function(){
            if (this.mastEquipment.val() === '-2'){
                this.mastEqLinked.hide();
            } else {
                this.mastEqLinked.show();
            }
            if (this.mastEquipment.val() !== '0'){
                this.mastEqLinked.each($.proxy(function(index, element) {
                    var name = $(element).find('input').attr('name');
                    if (this.options.changedFields.hasOwnProperty(name)) {
                        // Remove changed field
                        delete this.options.changedFields[name];
                    }
                }, this));
            }
        }, this));
        
        this.antennaModel.change($.proxy(function() {
            var antennaModel = this.antennaModel;
            if (antennaModel.val() === '-2') {
                antennaModel.prop('disabled', true);
                if ($('#' + antennaModel.attr('id') + '-overlay').length) {
                    $('#' + antennaModel.attr('id') + '-overlay').remove();
                }
                this.createOverlay(antennaModel, function() {
                    $(this).remove();
                    antennaModel.prop('disabled', false);
                    antennaModel.focus();
                    var event = document.createEvent('MouseEvents');
                    event.initMouseEvent('mousedown', true, true, window);
                    document.getElementById('model').dispatchEvent(event);
                });
            } else {
                this.antennaModel.prop('disabled', false);
            }
        }, this));
        this.antennaModel.blur($.proxy(function() {this.antennaModel.change()}, this));

        if (this.options.isInitial) {
            this.form.serializeArray().map($.proxy(function(x) {
                this.options.initialFields[x.name] = x.value;
            }, this));
        } else {
            // set form value
            $.each(this.options.initialFields, $.proxy(function(key, value) {
                if (!this.options.changedFields.hasOwnProperty(key)) {
                    $('[name="' + key + '"]').val(value);
                }
            }, this));
        }
        this.mastEquipment.change();
        this.antennaModel.change();
    };

    BulkEdit.prototype.isDifferentField = function(element) {
        return -1 !== $.inArray(element.attr('name'), this.options.differentFields)  && !this.isChangedField(element.attr('name'));
    };

    BulkEdit.prototype.isChangedField = function(field) {
        return this.options.changedFields.hasOwnProperty(field);
    };

    BulkEdit.prototype.overlay = function(element) {
        if(!element.is('select')) {
            element.val('Edit to change value').prop('disabled', true);
            this.createOverlay(element, function() {
                $(this).remove();
                element.trigger('click');
                element.focus();
            });
        }
    };

    BulkEdit.prototype.createOverlay = function(element, clickHandler) {
        $overlay = $('<div id="' + element.attr('id') + '-overlay"/>');
        var pos = element.position();
        $overlay.css({
            position: 'absolute',
            top: pos.top,
            left: pos.left,
            width: element.outerWidth(),
            height: element.outerHeight(),
            zIndex: 10000,
            opacity: 0
        }).click(clickHandler);
        element.parent().append($overlay);
    };

    BulkEdit.prototype.removeOverlay = function(event) {
        var el = $(event.target);
        if (el.is(':disabled')) {
            el.val('').prop('disabled', false);
        }
    };

    BulkEdit.prototype.refreshOverlay = function() {
        $(':input').each($.proxy(function (index, element) {
            $('#' + element.id + '-overlay').remove();
            var el = $(element);
            if (this.isDifferentField(el)){
                this.overlay(el);
            }
        }, this));
        this.antennaModel.change();
    };

    BulkEdit.prototype.text = function(elem) {
        var value;
        // On bulk edit it has only input:text or select or textarea
        if (elem.is('input:text') || elem.is('textarea')) {
            value = elem.val();
        } else {
            value = elem.find('option:selected').text();
        }
        return value;
    };

    BulkEdit.prototype.onChange = function(event) {
        var field = $(event.target);
        var name = field.attr('name');
        var initialValue = this.options.initialFields[name] === undefined ? '' : this.options.initialFields[name].toString().toLowerCase();
        var value = field.val().toLowerCase();
        if (initialValue !== value) {
            this.options.changedFields[name] = field.val();
        } else {
            if (this.options.changedFields.hasOwnProperty(name)) {
                delete this.options.changedFields[name];
            }
        }
    };
    
    BulkEdit.prototype.validate = function(event) {
      // Show a confirmation before send change
      var text = 'You will modify the following information on ' + this.options.ids.length + ' stations:<p><ul>';
      var displayedText = {};
      $.each(this.options.changedFields, $.proxy(function(key, value) {
          var elem = $('[name="' + key + '"]');
          displayedText[key] = this.text(elem);
          text += '<li>' + tapMessages[key] + ': ' + displayedText[key] + '</li>';
      }, this));
      text += '</ul></p>Continue?';
      var popupOptions = {
          popupTitle: 'Bulk edit',
          popupLinks: '.bulk-confirm',
          modal: true,
          closeOnEscape: false,
          displayClose: false,
          resizable: true,
          buttons: [{
              text: 'Continue',
              click: $.proxy(function() {
                  confirmPopup.popup.dialog('close');
                  this.form.append($('<input/>', {
                      type: 'hidden',
                      name: 'initialFields',
                      value: JSON.stringify(this.options.initialFields)
                  }));
                  $.each(this.options.ids, $.proxy(function(index, id) {
                      this.form.append($('<input/>', {
                          type: 'hidden',
                          name: 'ids',
                          value: id
                      }));
                  }, this));
                  $.each(this.options.differentFields, $.proxy(function(index, field) {
                      this.form.append($('<input/>', {
                          type: 'hidden',
                          name: 'fields',
                          value: field
                      }));
                  }, this));
                  this.form.append($('<input/>', {
                      type: 'hidden',
                      name: 'changedFields',
                      value: JSON.stringify(this.options.changedFields)
                  }));
                  this.form.append($('<input/>', {
                      type: 'hidden',
                      name: 'displayedText',
                      value: JSON.stringify(displayedText)
                  }));
                  this.form.submit();
              }, this)
          }, {
              text: 'Cancel',
              click: function() {
                  confirmPopup.popup.dialog('close');
              }
          }]
      };
      var confirmPopup = new PopupDialog('#content', popupOptions);
      confirmPopup.popup.dialog('open');
      confirmPopup.setContent(text);
    };
    
    return BulkEdit;
});
